import { useMemo } from 'react'
import { Portfolio } from 'types/rewards'

interface UseWithdrawCalculationsProps {
  selectedCurrency: string
  userPortfolios: Portfolio[]
  enteredAmount: string
  isRemoveAllocation: boolean
}

interface UseWithdrawCalculationsReturn {
  currentPortfolio: Portfolio | undefined
  blockedBalance: string
  remainingAmount: number
}

export const useWithdrawCalculations = ({
  selectedCurrency,
  userPortfolios,
  enteredAmount,
  isRemoveAllocation,
}: UseWithdrawCalculationsProps): UseWithdrawCalculationsReturn => {
  const currentPortfolio = useMemo(
    () => userPortfolios.find(p => p.currency === selectedCurrency),
    [userPortfolios, selectedCurrency]
  )

  const blockedBalance = useMemo(() => currentPortfolio?.balance || '0', [currentPortfolio])

  const remainingAmount = useMemo(() => {
    if (!isRemoveAllocation || !enteredAmount) return 0
    const blocked = Number.parseFloat(blockedBalance)
    const amount = Number.parseFloat(enteredAmount)
    return Math.max(0, blocked - amount)
  }, [isRemoveAllocation, blockedBalance, enteredAmount])

  return {
    currentPortfolio,
    blockedBalance,
    remainingAmount,
  }
}
